import { useTranslation } from 'next-i18next';

import { ExpertCard } from '@catawiki/cata-style';

import { FullWidthScrollable } from '@/shared/components/FullWidthScrollable/FullWidthScrollable';

import { useExpertsQuery } from '../hooks/queries/useExpertsQuery';

export const ExpertsGallery = () => {
  const { t } = useTranslation();
  const { expertsList } = useExpertsQuery();

  if (!expertsList?.length) {
    return null;
  }
  return (
    <FullWidthScrollable>
      {expertsList.map((exp) => (
        <div key={exp.name} className="tw:w-full">
          <ExpertCard
            url={'#'}
            mainImage={exp.main_image}
            name={exp.name}
            imageClassName="tw:w-full"
            expertise={
              exp.gender === 'Male'
                ? t('els.review.expert_in', {
                    category: exp.expertise,
                  })
                : t('els.review.expert_in_female', {
                    category: exp.expertise,
                  })
            }
          />
        </div>
      ))}
    </FullWidthScrollable>
  );
};
